import Utils from './utils';
import AccessControl from "./access_control";
import DataStore from './data-store';
import { consumePreSigninLocation } from './signin-redirect';

export default class AuthUtils {
    static handleAuthSuccess = (response, data, callback, errorCallback) => {
        DataStore.updateUserData(data, response.data, response.data.token);
        if (data.password_expired) {
            callback('/settings');
            return;
        }

        const previousLocation = consumePreSigninLocation();
        if (previousLocation) {
            callback(previousLocation);
            return;
        }

        if (!data.isMobile) {
            AccessControl.redirectToDefaultLanding(data, callback, "/dashboard");
        } else if (Utils.userHasPageAccess(data, "expenses")) {
            callback('/expenses_accounts');
        } else {
            data.username = null;
            errorCallback(data.t.read("signin.invalid_credentials_provided"));
        }
    }
}
